import { VeltPresence, VeltCursor, useVeltClient } from '@veltdev/react';
import { useEffect } from 'react';
import './FlockPage.css';

function FlockPage() {

  const { client } = useVeltClient();

  useEffect(() => {
    if (!client) return;

    const selectionElement = client.getSelectionElement();
    selectionElement.enableLiveSelection();

    const presenceElement = client.getPresenceElement();

    // @ts-ignore
    presenceElement.enableFlockMode({
      disableDefaultNavigation: true
    });

  }, [client]);

  useEffect(() => {
    window.onblur = (event) => {
        event.stopImmediatePropagation();
    };
  });

  return (
    <div id="flockModifier">
      <VeltCursor />
      <div className="mainView">
        <p className="boujeeText">Click on the avatar to start flock mode.</p>
        <VeltPresence />
      </div>
      <div className="colorBlock red"></div>
      <div className="colorBlock orange"></div>
      <div className="colorBlock yellow"></div>
      <div className="colorBlock green"></div>
      <div className="colorBlock blue"></div>
      <div className="colorBlock indigo"></div>
      <div className="colorBlock violet"></div>
    </div>
  )
}

export default FlockPage;